import React from 'react';
import { Button, ButtonGroup, FormControl, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  FaArrowLeft,
  FaArrowRight,
  FaFastBackward,
  FaFastForward,
} from 'react-icons/fa';

import { bsTiny } from '../../../helpers/ui.helper';
import FlatSelect from '../../form/FlatSelect';

interface Props {
  gotoPage: (page: number) => void;
  previousPage: () => void;
  canPreviousPage: boolean;
  nextPage: () => void;
  canNextPage: boolean;
  pageCount: number;
  pageIndex: number;
  pageSize: number;
  setPageSize: (newValue: number) => void;
}

export const PaginationButtons: React.FC<Props> = ({
  gotoPage,
  previousPage,
  canPreviousPage,
  nextPage,
  canNextPage,
  pageCount,
  pageIndex,
  pageSize,
  setPageSize,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <ButtonGroup>
        <Button
          variant="outline-secondary"
          size={bsTiny}
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
        >
          {<FaFastBackward />}
        </Button>
        <Button
          variant="outline-secondary"
          size={bsTiny}
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          {<FaArrowLeft />}
        </Button>
        <Button
          variant="outline-secondary"
          size={bsTiny}
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          {<FaArrowRight />}
        </Button>
        <Button
          variant="outline-secondary"
          size={bsTiny}
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        >
          {<FaFastForward />}
        </Button>
      </ButtonGroup>
      <InputGroup size={bsTiny}>
        <InputGroup.Text>{t('rt-pageText')}</InputGroup.Text>
        <FormControl
          type="number"
          value={pageIndex + 1}
          onChange={e => {
            const page = e.target.value ? Number(e.target.value) - 1 : 0;
            gotoPage(page);
          }}
          style={{ width: '100px' }}
        />
        <InputGroup.Text>
          {t('rt-ofText')} {pageCount}
        </InputGroup.Text>
      </InputGroup>
      <FlatSelect
        options={[10, 20, 50, 100, 250]}
        labels={[10, 20, 50, 100, 250].map(
          pageSize => `${pageSize} ${t('rt-rowsText')}`
        )}
        value={pageSize}
        onValueChange={setPageSize}
        name="pageSize"
      />
    </>
  );
};
